import { Play, Pause, Maximize2, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { usePlayer } from "@/context/PlayerContext";
import { fileUrl } from "@/lib/api";

export default function TrackRow({ track, index, list, onDelete }) {
  const { current, isPlaying, playTrack } = usePlayer();
  const nav = useNavigate();
  const active = current && current.id === track.id;
  const cover = fileUrl(track.cover_file_id);

  const openPage = (e) => {
    e.stopPropagation();
    nav(`/track/${track.id}`);
  };

  return (
    <div
      data-testid={`track-row-${track.id}`}
      onClick={() => playTrack(track, list)}
      className={`group flex items-center gap-4 px-4 py-3 border-b border-border cursor-pointer transition-colors ${
        active ? "bg-primary/10" : "hover:bg-white/5"
      }`}
    >
      <div className="w-6 text-center shrink-0">
        {active && isPlaying ? (
          <div className="flex items-end gap-0.5 h-4 justify-center">
            <span className="eq-bar w-0.5 bg-primary" style={{ animationDelay: "0s" }} />
            <span className="eq-bar w-0.5 bg-primary" style={{ animationDelay: "0.2s" }} />
            <span className="eq-bar w-0.5 bg-primary" style={{ animationDelay: "0.4s" }} />
          </div>
        ) : (
          <>
            <span className="text-sm text-muted-foreground group-hover:hidden tabular-nums">{typeof index === "number" ? index + 1 : "•"}</span>
            {active ? <Pause size={16} className="hidden group-hover:block mx-auto text-primary" /> : <Play size={16} className="hidden group-hover:block mx-auto" />}
          </>
        )}
      </div>
      {cover && (
        <div className="w-10 h-10 bg-secondary border border-border shrink-0 overflow-hidden hidden sm:block">
          <img src={cover} alt="" className="w-full h-full object-cover" />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className={`font-display font-medium truncate ${active ? "text-primary" : ""}`}>{track.title}</div>
        <div className="text-xs text-muted-foreground truncate">{track.artist}{track.genre ? ` · ${track.genre}` : ""}</div>
      </div>
      <div className="hidden md:block text-xs text-muted-foreground tabular-nums shrink-0">{track.plays || 0} plays</div>
      <button
        data-testid={`track-expand-${track.id}`}
        onClick={openPage}
        title="Open track page"
        className="shrink-0 text-muted-foreground hover:text-primary p-1.5 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity"
      >
        <Maximize2 size={16} />
      </button>
      {onDelete && (
        <button
          data-testid={`track-delete-${track.id}`}
          onClick={(e) => { e.stopPropagation(); onDelete(track); }}
          title="Delete track"
          className="shrink-0 text-muted-foreground hover:text-primary p-1.5"
        >
          <Trash2 size={16} />
        </button>
      )}
    </div>
  );
}
